import FeedbackCard from './FeedbackCard.vue';

export default FeedbackCard;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/FeedbackCard/index.ts